import {commonConfirmationBulkDelete} from "../../../../hoc/commonConfirmationBulkDelete";

const BulkWriteOffDelete = commonConfirmationBulkDelete('BulkWriteOffDelete');
export default BulkWriteOffDelete;
